import { AuthGuard } from './auth/auth.guard';
import { AuthInterceptor } from './auth/auth.interceptor';
import { LoadingInterceptor } from './interceptors/loading.interceptor';

import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { PROFESSOR_API_URL } from 'professor-data-access';
import { PLANO_AULA_API_URL } from 'plano-aula-data-access';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MensagemModule } from './shared/components/mensagem/mensagem.module';

import {
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData,
} from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgxGoogleAnalyticsModule } from 'ngx-google-analytics';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { FeedbackUsuarioModule } from './feedback-usuario/feedback-usuario.module';
import { CpfInterceptor } from './interceptors/cpf.interceptor';
import { HttpErrorsInterceptor } from './interceptors/http-errors.interceptor';
import { CachingInterceptor } from './interceptors/no-cache.interceptor';
import { LoadingComponent } from './loading/loading.component';
registerLocaleData(localePt, 'pt');

@NgModule({
  declarations: [AppComponent, LoadingComponent],
  exports: [LoadingComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    MatSidenavModule,
    MensagemModule,
    MatProgressSpinnerModule,
    NgbModule,
    NgIdleKeepaliveModule.forRoot(),
    NgxGoogleAnalyticsModule.forRoot('G-MEZQ32YQ9V'),
    FeedbackUsuarioModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorsInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: CachingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CpfInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
    // Configuração da URL da API de professores baseada no environment
    { provide: PROFESSOR_API_URL, useValue: environment.apiProfessor },
    // Configuração da URL da API de plano de aula baseada no environment
    { provide: PLANO_AULA_API_URL, useValue: environment.apiProfessor },
    provideEnvironmentNgxMask({ validation: false }),
    provideCharts(withDefaultRegisterables()),
  ],
})
export class AppModule {}
